import script from "./SubmitSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitSuccess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__